import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageHero } from "@/components/common/PageHero";
import { Reveal } from "@/components/common/Reveal";
import { SECTORS, IMAGES } from "@/lib/content";
import { useSeo } from "@/lib/seo";

export default function Metiers() {
  useSeo({
    title: "Nos Métiers — Communication visuelle & métiers techniques | Losta Group",
    description:
      "Enseignes, signalétique, impression numérique, covering, smart glass, métallerie, éclairage LED, portails : les familles de métiers techniques que Losta Group acquiert et développe.",
    path: "/metiers",
  });
  return (
    <>
      <PageHero
        eyebrow="Nos Métiers"
        lines={["Des savoir-faire", "techniques complémentaires."]}
        sub="Losta Group fédère neuf familles de métiers autour de la communication visuelle et des activités techniques complémentaires."
        image={IMAGES.heroAlt}
      />
      <section className="py-16 sm:py-24">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8 space-y-20">
          {SECTORS.map((s, i) => (
            <Reveal key={s.slug}>
              <div className={`grid gap-8 lg:grid-cols-2 lg:gap-14 items-center ${i % 2 ? "lg:[direction:rtl]" : ""}`}>
                <div className="relative overflow-hidden rounded-2xl border border-white/10 group aspect-[4/3] [direction:ltr]">
                  <img src={s.img} alt={s.title} loading="lazy" className="img-duotone h-full w-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#07080B]/60 to-transparent" />
                  <span className="absolute top-4 left-4 font-mono text-xs tracking-widest text-gold">{s.n}</span>
                </div>
                <div className="[direction:ltr]">
                  <h2 className="font-serif text-3xl sm:text-4xl text-white">{s.title}</h2>
                  <p className="mt-3 text-base text-[var(--txt-2)] font-light leading-relaxed">{s.short}</p>
                  <div className="mt-6 flex flex-wrap gap-2">
                    {s.items.map((it) => (
                      <span key={it} className="rounded-full border border-white/10 bg-white/[0.02] px-3.5 py-1.5 text-xs text-slate-300">{it}</span>
                    ))}
                  </div>
                  <Link to={`/acquisitions/${s.slug}`} className="mt-6 inline-flex items-center gap-1.5 text-sm text-gold hover:gap-2.5 transition-all" data-testid={`metier-link-${s.slug}`}>
                    Entreprises recherchées <ArrowUpRight className="h-4 w-4" />
                  </Link>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
